export default __webpack_public_path__ + "static/media/wegovy-innercap-remove.b82b632c.mp4";